"use client";

import React from "react";
import { Pagination, EffectCreative, Autoplay } from "swiper/modules";
import { Badge } from "@/components/ui/badge";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { formatDate } from "@/utils/utils";
import "swiper/css";
import "swiper/css/pagination";
import { TTestimonials } from "./Testimonials";
import { FaLinkedin } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";

const TestimonialsSwiper = ({ lang, testimonials }: TTestimonials) => {
  const t = useTranslations();

  return (
    <div className="w-full h-full">
      {testimonials.length > 0 ? (
        <Swiper
          dir={lang === "ar" ? "rtl" : "ltr"}
          slidesPerView={1}
          loop
          autoplay={{ delay: 8000, disableOnInteraction: false }}
          speed={1000}
          pagination={{ clickable: true }}
          grabCursor
          effect="creative"
          creativeEffect={{
            prev: { shadow: true, translate: [0, 0, -400] },
            next: { translate: [lang === "ar" ? "-100%" : "100%", 0, 0] },
          }}
          modules={[EffectCreative, Pagination, Autoplay]}
          className="mySwiper5 w-full h-full"
        >
          {testimonials.map((item) => (
            <SwiperSlide
              key={item?._id}
              className="!h-full !shadow-xl bg-white dark:bg-input/30 dark:shadow-none dark:backdrop-blur-3xl rounded-[5px] border !border-gray-200 dark:!border-input p-4 !flex flex-col"
            >
              <div className="flex justify-between mb-4 items-center">
                <div className="flex items-center gap-3">
                  <p className="text-xl font-bold text-gray-800 dark:text-gray-200 flex justify-center items-center bg-gray-200 dark:bg-gray-700 rounded-full w-16 h-16">
                    {item?.firstName[0].toUpperCase()}
                    {item?.lastName[0].toUpperCase()}
                  </p>
                  <div className="flex flex-col">
                    <p className="text-lg font-semibold capitalize">
                      {item?.firstName} {item?.lastName}
                    </p>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      {item?.createdAt && formatDate(item.createdAt)}
                    </p>
                  </div>
                </div>

                <Link
                  href={`${item?.linkedInUrl}`}
                  aria-label="LinkedIn"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-1 bg-black/5 dark:bg-white/5 rounded-[5px] shadow-sm backdrop-blur-2xl"
                >
                  <FaLinkedin size={30} />
                </Link>
              </div>
              <q className="text-center text-xs md:text-base  text-gray-600 dark:text-gray-300 leading-[1.8] pb-5">
                {item?.message}
              </q>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className="flex flex-col gap-4 justify-center items-center h-full">
          <Badge
            variant="outline"
            className="text-lg font-semibold text-white capitalize rounded-[5px]"
          >
            {t("No testimonials yet")}
          </Badge>
        </div>
      )}
    </div>
  );
};

export default TestimonialsSwiper;
